import { useMediaQuery } from 'react-responsive'
import { RESPONSIVE_BREAKPOINTS } from '@/features/responsive/model/constants.ts'

type Breakpoint = 'wide-screen' | 'desktop' | 'tablet'

const responsiveQueries: Record<Breakpoint, string> = {
  'wide-screen': `(min-width: ${RESPONSIVE_BREAKPOINTS.WIDE_SCREEN}px)`,
  desktop: `(min-width: ${RESPONSIVE_BREAKPOINTS.DESKTOP}px)`,
  tablet: `(min-width: ${RESPONSIVE_BREAKPOINTS.TABLET}px)`,
}

export const useResponsive = (breakpoint: Breakpoint) => {
  return useMediaQuery({ query: responsiveQueries[breakpoint] })
}
